export const ScheduleRequestHistoryTableRoute = '/schedule/request-history';
